module.exports = __webpack_public_path__ + "img/cs2_cheat_v_2_0.18884f57.png";